// extracted by mini-css-extract-plugin
module.exports = {"DataTableWrapper":"data-table_DataTableWrapper__2u34q","DataTable":"data-table_DataTable__2DVHe"};